// src/pages/Register.js
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useLang } from '../context/LanguageContext';
import { registerUser } from '../firebase/services';

export default function Register() {
  const { t } = useLang();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: '', email: '', password: '', confirm: '' });
  const [agreed, setAgreed] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (form.password !== form.confirm) { setError('Passwords do not match.'); return; }
    if (!agreed) { setError('Please accept the terms.'); return; }
    setLoading(true);
    try {
      await registerUser(form.email, form.password, form.name);
      navigate('/dashboard');
    } catch (err) {
      setError(err.message.replace('Firebase: ', '').replace(/\(auth.*\)/, ''));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={s.page}>
      <div style={s.card}>
        <Link to="/" style={s.logo}>COA<span style={s.logoAccent}>Lab</span></Link>
        <h1 style={s.title}>{t('auth.register.title')}</h1>
        <p style={s.sub}>{t('auth.register.subtitle')}</p>
        {error && <div style={s.error}>{error}</div>}
        <form onSubmit={handleSubmit} style={s.form}>
          <label style={s.label}>{t('auth.register.name')}</label>
          <input style={s.input} type="text" value={form.name} onChange={set('name')} required autoComplete="name" />
          <label style={s.label}>{t('auth.register.email')}</label>
          <input style={s.input} type="email" value={form.email} onChange={set('email')} required autoComplete="email" />
          <label style={s.label}>{t('auth.register.password')}</label>
          <input style={s.input} type="password" value={form.password} onChange={set('password')} required minLength={6} />
          <label style={s.label}>{t('auth.register.confirm')}</label>
          <input style={s.input} type="password" value={form.confirm} onChange={set('confirm')} required />
          <label style={s.checkboxLabel}>
            <input type="checkbox" checked={agreed} onChange={e => setAgreed(e.target.checked)} style={{ marginRight: 8 }} />
            <span style={{ fontSize: 13, color: 'rgba(255,255,255,0.6)' }}>{t('auth.register.terms')}</span>
          </label>
          <button type="submit" style={s.submit} disabled={loading}>
            {loading ? t('common.loading') : t('auth.register.submit')}
          </button>
        </form>
        <p style={s.switchText}>
          {t('auth.register.hasAccount')}{' '}
          <Link to="/login" style={s.switchLink}>{t('auth.register.signIn')}</Link>
        </p>
      </div>
    </div>
  );
}

const s = {
  page: { minHeight: '100vh', background: '#070F2B', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20, fontFamily: "'Inter', sans-serif" },
  card: { background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 20, padding: '40px 36px', width: '100%', maxWidth: 440 },
  logo: { display: 'block', fontSize: 22, fontWeight: 800, color: '#fff', textDecoration: 'none', marginBottom: 28 },
  logoAccent: { color: '#4A9EFF' },
  title: { fontSize: 26, fontWeight: 800, color: '#fff', margin: '0 0 6px' },
  sub: { fontSize: 14, color: 'rgba(255,255,255,0.55)', marginBottom: 28 },
  error: { background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.3)', borderRadius: 10, padding: '10px 14px', color: '#FCA5A5', fontSize: 13, marginBottom: 16 },
  form: { display: 'flex', flexDirection: 'column', gap: 4 },
  label: { fontSize: 13, fontWeight: 600, color: 'rgba(255,255,255,0.7)', marginBottom: 4, marginTop: 8 },
  input: { background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.12)', borderRadius: 10, padding: '12px 14px', color: '#fff', fontSize: 14, outline: 'none' },
  checkboxLabel: { display: 'flex', alignItems: 'flex-start', marginTop: 12, cursor: 'pointer' },
  submit: { background: 'linear-gradient(135deg, #1E5EFF, #0A3DD4)', color: '#fff', border: 'none', borderRadius: 12, padding: '13px', fontSize: 15, fontWeight: 700, cursor: 'pointer', marginTop: 16 },
  switchText: { textAlign: 'center', fontSize: 14, color: 'rgba(255,255,255,0.5)', marginTop: 20 },
  switchLink: { color: '#4A9EFF', textDecoration: 'none', fontWeight: 600 },
};
